module.exports = __webpack_public_path__ + "static/media/elcare.c4f83ab1.png";